import { ReadMoreBlockType, ReadMoreTarget } from './types'
import { ContentBlock } from '@app/components/Guide/types/guide.types'

const firstTarget = (target?: ReadMoreTarget | ReadMoreTarget[]): ReadMoreTarget | undefined =>
  Array.isArray(target) ? target[0] : target

export const getReadMoreTitle = (block: ReadMoreBlockType) =>
  block.title_override || firstTarget(block.target)?.title

export const getReadMoreDescription = (block: ReadMoreBlockType) =>
  firstTarget(block.target)?.description

export const getReadMoreSlug = (block: ReadMoreBlockType) => firstTarget(block.target)?.slug

export const getReadMoreSubTabSlug = (block: ReadMoreBlockType) =>
  firstTarget(block.target)?.sub_tabs?.[0]?.slug

export const getReadMoreMainTopicSlug = (block: ReadMoreBlockType) =>
  firstTarget(block.target)?.sub_tabs?.[0]?.main_topic?.slug

export const getReadMoreImage = (block: ReadMoreBlockType) => {
  const target = firstTarget(block.target)
  return target?.hero_image?.formats?.small?.url || target?.hero_image?.url
}

// For References Block
export const hasReferencesBlock = (blocks?: ContentBlock[] | null): boolean =>
  !!blocks?.some((block) => block.__component === 'content.references')
